module.exports = __webpack_public_path__ + "static/dhampir-savra-sunstar-a11c82971bfcbeaace92efeda31bd67f.png";